import { AxiosInstance } from 'axios'
import { createAxiosClientWithAladinBearer } from '@/utils/axios'
import ImportService from './import.service'

export default class ElectronicInvoicingAddressesService {
  private readonly membershipApiHost: string

  private api: AxiosInstance

  constructor(membershipApiHost: string) {
    this.membershipApiHost = membershipApiHost
    this.api = createAxiosClientWithAladinBearer(`${membershipApiHost}`)
  }

  async import(distributorId, file) {
    return ImportService.import(
      `${this.membershipApiHost}/backoffice/v1/import/partners/${distributorId}/electronic-invoicing-addresses`,
      file,
    )
  }

  async downloadElectronicInvoicingAddresses(distributorId: number, partnerName: string) {
    const response = await this.api.get(
      `/backoffice/v1/export/partners/${distributorId}/electronic-invoicing-addresses`,
      { headers: { accept: 'text/csv' } },
    )

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', ImportService.createFileName(partnerName, 'electronic-invoicing-addresses'))
    document.body.appendChild(link)
    link.click()
  }
}
